import type {
  CreateCompanyBody,
  CreateCompanyResponse,
  EditCompanyBody,
  EditCompanyMembersBody,
  EditCompanyMembersResponse,
  EditCompanyResponse,
  ListCompaniesQuery,
  ListCompaniesResponse,
  ListDemoDayCompaniesQuery,
  ListDemoDayCompaniesResponse,
  RetrieveCompanyQuery,
  RetrieveCompanyResponse,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class CompanyService extends BaseService {
  retrieveCompany(
    query: RetrieveCompanyQuery,
  ): Promise<RetrieveCompanyResponse> {
    return this.client.send('/api/company', {
      method: 'GET',
      query,
    });
  }

  listCompanies(query?: ListCompaniesQuery): Promise<ListCompaniesResponse> {
    return this.client.send('/api/companies', {
      method: 'GET',
      query,
    });
  }

  listDemoDayCompanies(
    query?: ListDemoDayCompaniesQuery,
  ): Promise<ListDemoDayCompaniesResponse> {
    return this.client.send('/api/demo-day/companies', {
      method: 'GET',
      query,
    });
  }

  createCompany(body: CreateCompanyBody): Promise<CreateCompanyResponse> {
    return this.client.send('/api/companies', {
      method: 'POST',
      body,
    });
  }

  editCompany(body: EditCompanyBody): Promise<EditCompanyResponse> {
    return this.client.send('/api/companies', {
      method: 'PUT',
      body,
    });
  }

  deleteCompany(id: number): Promise<{ success: boolean }> {
    return this.client.send(`/api/companies/${id}`, {
      method: 'DELETE',
    });
  }

  editMembers(
    body: EditCompanyMembersBody,
  ): Promise<EditCompanyMembersResponse> {
    return this.client.send('/api/companies/members', {
      method: 'PUT',
      body,
    });
  }
}
